import React, { useEffect, useState } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import {
   fetchAllFleetAsync,
   fetchAllLaneAsync,
   fetchDriverRecordByVendorIdAsync,
   fetchLaneRecordByIdAsync,
} from "../../../redux/features/driverMaster";
import { useDispatch, useSelector } from "react-redux";

import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomDateTimePicker from "../../../components/common/CustomDateTimePicker/CustomDateTimePicker";
import * as Yup from "yup";
import CustomDatePicker from "../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomTextArea from "../../../components/common/CustomTextArea/CustomTextArea";
import CustomFileUpload from "../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomModal from "../../../components/common/Modal";
import { useNavigate } from "react-router-dom";
import { addTripMasterAsync } from "../../../redux/features/tripMaster";
import toast from "react-hot-toast";
import { Form, FormikProvider, useFormik } from "formik";
import RouteNames from "../../../AppRoutes/RouteName";
import useTrip from "../../../Hooks/useTrip";

const validateSchema = Yup.object().shape({
   vehicle_no: Yup.string().required("Vehicle number is required"),
   driver_id: Yup.string().required("Driver is required"),
   drivername: Yup.string().required("Driver name is required"),
   driverno: Yup.string().required("Driver number is required"),
   laneName: Yup.string().required("Lane name is required"),
   customername: Yup.string().required("Customer name is required"),
   origin: Yup.string().required("Origin is required"),
   destination: Yup.string().required("Destination is required"),
   //EWayBillNo: Yup.string().required("E-Way bill bumber is required"),
   // EWayExpiry: Yup.string().required("E-Way bill expiry eate & eime is required"),
   invoiceNo: Yup.string().required("Invoice number is required"),
   invoiceDate: Yup.string().required("Invoice date is required"),
   invoiceValue: Yup.string().required("Invoice value is required"),
   // customer_eisakuLRNo: Yup.string().required("Customer/ LR no is required"),
   vehicleReportedDate: Yup.string().required("Vehicle Reported Date is required"),
   vehicleDispatchDate: Yup.string().required("Vehicle Dispatch Date is required"),
   actualDriverTripAdvance: Yup.string().required("Driver trip is required"),
   loadingCharges: Yup.string().required("Loading charges is required"),
   unloadingCharge: Yup.string().required("Loading charges is required"),
   dieselRate: Yup.string().required("Diesel price is required"),
   adblueRate: Yup.string().required("Adblue price is required"),
   //actualMiscExpenceRemarks: Yup.string().required("Expence is required"),
});

export default function ContractualTripAdd() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { laneForTripApiCall, laneForTrip } = useTrip();
   const driverMaster = useSelector((state) => state.driverMaster);

   const [isDisabled, setIsdisabled] = useState(false);

   const [isModalVisible, setIsModalVisible] = useState(false);
   const handleShowModal = () => {
      setIsModalVisible(true);
   };
   const handleCloseModal = () => {
      setIsModalVisible(false);
   };

   const vendorsData =
      driverMaster?.singleVehicleMaster?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
      })) || [];

   const lanesData =
      laneForTrip?.map?.((item) => ({
         label: item?.name,
         value: item?.id,
      })) || [];

   const storeRecord = (formData) => {
      const data = { ...formData };

      const newData = new FormData();
      newData.append("lanetype", "contactual");

      Object.keys(data).forEach((key) => {
         if (key === "loadingCharges" || key === "unloadingCharge") {
            const value = parseFloat(data[key]) || 0;
            newData.append(key, value.toFixed(2));
         } else {
            newData.append(key, data[key]);
         }
      });

      dispatch(backdropLoadingAction(true));

      dispatch(
         addTripMasterAsync({
            data: newData,
            err: () => {
               //toast.error("Something went wrong !");
               dispatch(backdropLoadingAction(false));
               /// navigate(RouteNames.contractualTripView);
            },
            done: () => {
               toast.success("Record added successfully !");
               dispatch(backdropLoadingAction(false));
               navigate(RouteNames.contractualTripView);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: {
         vehicle_no: "",
         driver_id: "",
         drivername: "",
         driverno: "",
         laneName: "",
         customername: "",
         origin: "",
         destination: "",
         EWayBillNo: "",
         EWayExpiry: "",
         invoiceNo: "",
         invoiceDate: "",
         invoiceValue: "",
         customer_eisakuLRNo: "",
         vehicleReportedDate: "",
         vehicleDispatchDate: "",
         actualDriverTripAdvance: "",
         loadingCharges: "",
         unloadingCharge: "",
         dieselRate: "",
         adblueRate: "",
         actualMiscExpenceRemarks: "",
      },
      validationSchema: validateSchema,
      onSubmit: storeRecord,
   });

   const { getFieldProps, handleSubmit, touched, errors, setFieldValue } = formik;

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchAllFleetAsync({
            done: () => dispatch(backdropLoadingAction(false)),
            err: () => dispatch(backdropLoadingAction(false)),
         }),
      );
   }, []);

   useEffect(() => {
      laneForTripApiCall();
   }, []);

   return (
      <div>
         <BodyHeader title="Add Trip Request" />

         <FormikProvider value={formik}>
            <Form>
               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">General Details</h3>
                  </div>

                  <div className="card-body">
                     <div className="row">
                        {/* Vehicle No */}
                        <div className="col-lg-4">
                           <label className="text-bold">Vehicle No.</label>
                           <CustomDropdown
                              require
                              disabled={isDisabled}
                              optionData={vendorsData}
                              {...getFieldProps("vehicle_no")}
                              errors={touched.vehicle_no && errors.vehicle_no}
                              message={errors.vehicle_no}
                              onChange={(value) => {
                                 if (value && value.length > 0 && value[0]?.value) {
                                    // Set the value in formik
                                    formik.setFieldValue("vehicle_no", value[0]?.value);

                                    // Dispatch Redux action
                                    dispatch(
                                       fetchDriverRecordByVendorIdAsync({
                                          id: value[0]?.value,

                                          err: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                          done: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                       }),
                                    ).then((res) => {
                                       formik.setFieldValue(
                                          "drivername",
                                          res?.payload?.name ?? "",
                                       );
                                       formik.setFieldValue(
                                          "driverno",
                                          res?.payload?.mobile ?? "",
                                       );
                                       formik.setFieldValue(
                                          "driver_id",
                                          res?.payload?.id ?? "",
                                       );
                                    });
                                 }
                              }}
                           />
                        </div>

                        {/* Driver Name */}
                        <div className="col-lg-4">
                           <CustomInput
                              disabled
                              label="Driver Name"
                              placeholder="Driver Name"
                              {...getFieldProps("drivername")}
                              errors={touched.drivername && errors.drivername}
                              message={errors.drivername}
                           />
                        </div>

                        {/* Driver No */}
                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              label="Driver No."
                              placeholder="Driver No."
                              {...getFieldProps("driverno")}
                              errors={touched.driverno && errors.driverno}
                              message={errors.driverno}
                           />
                        </div>
                     </div>
                  </div>
               </div>

               <div className="card card-primary">
                  <div className="card-header">
                     <h3 className="card-title">Lane Details</h3>
                  </div>

                  <div className="card-body">
                     <div className="row">
                        {/* lane name */}
                        <div className="col-lg-4">
                           <label className="text-bold">Lane Name</label>
                           <CustomDropdown
                              disabled={isDisabled}
                              optionData={lanesData}
                              {...getFieldProps("laneName")}
                              errors={touched.laneName && errors.laneName}
                              message={errors.laneName}
                              onChange={(value) => {
                                 if (value && value.length > 0 && value[0]?.value) {
                                    formik.setFieldValue("laneName", value[0]?.value);

                                    // Dispatch Redux action
                                    dispatch(
                                       fetchLaneRecordByIdAsync({
                                          id: value[0]?.value,

                                          err: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                          done: () => {
                                             dispatch(backdropLoadingAction(false));
                                          },
                                       }),
                                    ).then((res) => {
                                       formik.setFieldValue(
                                          "customername",
                                          res?.payload[0]?.customer_master?.name ?? "",
                                       );
                                       formik.setFieldValue(
                                          "origin",
                                          res?.payload[0]?.origin_location_master?.name ??
                                             "",
                                       );
                                       formik.setFieldValue(
                                          "destination",
                                          res?.payload[0]?.destination_location_master
                                             ?.name ?? "",
                                       );
                                    });
                                 }
                              }}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Customer Name"
                              placeholder="Customer Name"
                              {...getFieldProps("customername")}
                              errors={touched.customername && errors.customername}
                              message={errors.customername}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Origin"
                              placeholder="Origin"
                              {...getFieldProps("origin")}
                              errors={touched.origin && errors.origin}
                              message={errors.origin}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={true}
                              label="Destination"
                              {...getFieldProps("destination")}
                              errors={touched.destination && errors.destination}
                              message={errors.destination}
                           />
                        </div>

                        {/* E Way Bill No */}
                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              label="E waybill No."
                              placeholder="E waybill No."
                              {...getFieldProps("EWayBillNo")}
                              errors={touched.EWayBillNo && errors.EWayBillNo}
                              message={errors.EWayBillNo}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={isDisabled}
                              label="E Waybill Expiry Date & Time"
                              placeholder="E Waybill Expiry Date & Time"
                              min={new Date().toISOString().slice(0, 16)}
                              {...getFieldProps("EWayExpiry")}
                              errors={touched.EWayExpiry && errors.EWayExpiry}
                              message={errors.EWayExpiry}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              require
                              label="Invoice No."
                              placeholder="Invoice No."
                              {...getFieldProps("invoiceNo")}
                              errors={touched.invoiceNo && errors.invoiceNo}
                              message={errors.invoiceNo}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDatePicker
                              disabled={isDisabled}
                              require
                              label="Invoice Date"
                              placeholder="Invoice Date"
                              {...getFieldProps("invoiceDate")}
                              errors={touched.invoiceDate && errors.invoiceDate}
                              message={errors.invoiceDate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              require
                              label="Invoice value"
                              placeholder="Invoice value"
                              {...getFieldProps("invoiceValue")}
                              errors={touched.invoiceValue && errors.invoiceValue}
                              message={errors.invoiceValue}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              label="Customer / Logistics LR no."
                              id="customer_eisakuLRNo"
                              placeholder="Customer / Logistics LR no."
                              {...getFieldProps("customer_eisakuLRNo")}
                              errors={
                                 touched.customer_eisakuLRNo && errors.customer_eisakuLRNo
                              }
                              message={errors.customer_eisakuLRNo}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={isDisabled}
                              require
                              label="Vehicle reported date time"
                              min={new Date().toISOString().slice(0, 16)}
                              {...getFieldProps("vehicleReportedDate")}
                              errors={
                                 touched.vehicleReportedDate && errors.vehicleReportedDate
                              }
                              message={errors.vehicleReportedDate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomDateTimePicker
                              disabled={isDisabled}
                              require
                              label="Vehicle disptch date time"
                              min={new Date().toISOString().slice(0, 16)}
                              {...getFieldProps("vehicleDispatchDate")}
                              errors={
                                 touched.vehicleDispatchDate && errors.vehicleDispatchDate
                              }
                              message={errors.vehicleDispatchDate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              disabled={isDisabled}
                              require
                              label="Actual driver trip advance"
                              inputType="number"
                              placeholder="E.g 100Rs"
                              {...getFieldProps("actualDriverTripAdvance")}
                              errors={
                                 touched.actualDriverTripAdvance &&
                                 errors.actualDriverTripAdvance
                              }
                              message={errors.actualDriverTripAdvance}
                           />
                        </div>

                        {/* New fields comes from Lane these will be accessable by corporate admin  */}

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Loading charges"
                              id="loadingCharges"
                              placeholder="Enter amount"
                              {...getFieldProps(`loadingCharges`)}
                              errors={touched?.loadingCharges && errors?.loadingCharges}
                              message={errors?.loadingCharges}
                           />
                        </div>
                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Unloading charge"
                              id="unloadingCharge"
                              placeholder="Enter amount"
                              {...getFieldProps(`unloadingCharge`)}
                              errors={touched?.unloadingCharge && errors?.unloadingCharge}
                              message={errors?.unloadingCharge}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Diesel Rupees"
                              id="dieselRate"
                              placeholder="Enter diesel rate"
                              {...getFieldProps(`dieselRate`)}
                              errors={touched?.dieselRate && errors?.dieselRate}
                              message={errors?.dieselRate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              require
                              label="Adblue Rupees"
                              id="adblueRate"
                              placeholder="Enter adblue rate"
                              {...getFieldProps(`adblueRate`)}
                              errors={touched?.adblueRate && errors?.adblueRate}
                              message={errors?.adblueRate}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              label="Food Allowance"
                              id="foodAllowance"
                              placeholder="Enter amount"
                              {...getFieldProps(`foodAllowance`)}
                              errors={touched?.foodAllowance && errors?.foodAllowance}
                              message={errors?.foodAllowance}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              label="Police Expense"
                              id="police_expense"
                              placeholder="Enter amount"
                              {...getFieldProps(`policeExpense`)}
                              errors={touched?.policeExpense && errors?.policeExpense}
                              message={errors?.policeExpense}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              label="Parking"
                              id="parking"
                              placeholder="Enter amount"
                              {...getFieldProps(`parking`)}
                              errors={touched?.parking && errors?.parking}
                              message={errors?.parking}
                           />
                        </div>

                        <div className="col-lg-4">
                           <CustomInput
                              label="Miscellaneous Rate"
                              id="miscellaneousRate"
                              placeholder="Enter miscellaneous rate"
                              {...getFieldProps(`miscellaneousRate`)}
                              errors={
                                 touched?.miscellaneousRate && errors?.miscellaneousRate
                              }
                              message={errors?.miscellaneousRate}
                           />
                        </div>

                        {/* End of new fields */}

                        <div className="col-lg-12">
                           <CustomTextArea
                              disabled={isDisabled}
                              label="Miscellaneous Expense Remarks"
                              placeholder="Remarks"
                              {...getFieldProps("actualMiscExpenceRemarks")}
                              errors={
                                 touched.actualMiscExpenceRemarks &&
                                 errors.actualMiscExpenceRemarks
                              }
                              message={errors.actualMiscExpenceRemarks}
                           />
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-12 mt-4 text-center">
                  <button
                     className="btn btn-success px-4 py-3"
                     type="submit"
                     onClick={handleSubmit}
                  >
                     <h6 className="mb-0 text-uppercase">Save</h6>
                  </button>
               </div>
               <CustomModal
                  showModal={isModalVisible}
                  handleCloseModal={handleCloseModal}
                  child={<CustomTextArea />}
               />
            </Form>
         </FormikProvider>
      </div>
   );
}
